import { TransactionRowFragment } from 'services/graphql/fragments/Fragments';
import { PayOverTimeTransactionAnalyticsFragment } from 'services/graphql/fragments/PayOverTimeTransactionAnalytics';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import {
  IconFragment,
  VXLResponsiveTextFragment,
} from 'services/graphql/fragments/VxlStyles';
import { gql } from 'urql';

export const smartLedgerQuery = gql`
  query SmartLedgerComponents($accountId: ID!, $pagingToken: String) {
    smartLedgerComponents(accountId: $accountId, pagingToken: $pagingToken) {
      children {
        __typename
        ... on SLCollapsibleListComponent {
          id
          clickAnalytics {
            ...analytics
          }
          icon {
            ...IconFragment
          }
          iconV2
          secondaryText
          title {
            ...VXLResponsiveTextFragment
          }
          children {
            __typename
            ...TransactionRowFragment
            ...PayOverTimeTransactionAnalyticsFragment
          }
          footer {
            html
            id
            boldStyle {
              color
              fontStyle
            }
            textStyle {
              color
              fontStyle
            }
            linkStyle {
              color
              fontStyle
            }
            linkActions {
              ... on OpenWebUrlAction {
                id
                url
                analyticsEvent {
                  ...analytics
                }
              }
              ... on OpenPdfUrlAction {
                id
                url
                analyticsEvent {
                  ...analytics
                }
              }
              ... on PresentHtmlBottomSheetAction {
                id
                content
                __typename
                analyticsEvent {
                  ...analytics
                }
              }
            }
          }
        }
        ... on SLTitledListComponent {
          id
          icon {
            ...IconFragment
          }
          title {
            ...VXLResponsiveTextFragment
          }
          children {
            __typename
            ...TransactionRowFragment
            ...PayOverTimeTransactionAnalyticsFragment
          }
        }
      }
      id
      pagingToken
    }
  }
  ${TransactionRowFragment}
  ${PayOverTimeTransactionAnalyticsFragment}
  ${VXLResponsiveTextFragment}
  ${IconFragment}
  ${AnalyticsFragment}
`;

export default smartLedgerQuery;
